/**
 * 工程安装（engineeringInstallation）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/engineeringInstallation/ 下 constructionCompany（施工公司）、
 *          constructionManagement（施工管理：申请/已办/待办/签收池/图纸/审核/财务确认/
 *          领导审批/派单/验收/安装记录等）及其 modules 表单、弹窗、详情组件
 * 术语：工程安装=Engineering Installation，报装=Application，施工=Construction，
 *       施工公司=Construction Company，验收=Acceptance，竣工=Completion，
 *       材料=Material，设计=Design，开工=Start
 */
export default {
  // 通用词（与 en-US.js 保持一致，模块内自包含）
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '编辑': 'Edit',
  '删除': 'Delete',
  '新增': 'Add',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '操作': 'Action',
  '是': 'Yes',
  '否': 'No',
  '导出': 'Export',
  '下载': 'Download',
  '上传': 'Upload',
  '状态': 'Status',
  '名称': 'Name',
  '备注': 'Remark',
  '已选择 {count} 项': '{count} items selected',
  '确定删除吗?': 'Are you sure you want to delete?',
  '全部': 'All',
  '图片': 'Images',
  '附件': 'Attachment',
  // 工单 / 报装通用
  '工单编号': 'Work Order No.',
  '工单状态': 'Work Order Status',
  '工单紧急程度': 'Work Order Urgency',
  '报装编号': 'Application No.',
  '请输入报装编号': 'Please enter application No.',
  '报装类型': 'Application Type',
  '报装状态': 'Application Status',
  '报装申请信息': 'Installation Application Info',
  '紧急程度': 'Urgency',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '更新时间': 'Updated At',
  '来源': 'Source',
  '小程序': 'Mini Program',
  '公众号': 'Official Account',
  '微信端游客': 'WeChat Guest',
  '用户名称': 'Customer Name',
  '用户电话': 'Customer Phone',
  '当前节点处理人': 'Current Node Handler',
  '当前任务': 'Current Task',
  '历时': 'Duration',
  '请输入工单编号': 'Please enter work order no.',
  '请选择报装类型': 'Please select application type',
  '请选择报装类别': 'Please select application category',
  '请选择工单紧急程度': 'Please select work order urgency',
  '请选择紧急程度': 'Please select urgency',
  '请选择创建人员': 'Please select creator',
  '创建人员': 'Creator',
  '请选择状态': 'Select status',
  '处理中': 'Processing',
  '已结束': 'Finished',
  '换表': 'Meter Replacement',
  '个人新装': 'New Individual Installation',
  '企业新装': 'New Enterprise Installation',
  '故障报修': 'Fault Repair',
  '报停': 'Suspension',
  '复接': 'Reconnection',
  '用水': 'Water Use',
  '开启': 'On',
  '确定开启吗?': 'Are you sure to start?',
  '开启成功': 'Started successfully',
  '开启失败': 'Failed to start',
  '指派': 'Assign',
  '签收': 'Claim',
  '签收成功': 'Claimed successfully',
  '接单成功': 'Order accepted successfully',
  '转办成功': 'Transferred successfully',
  '委派成功': 'Delegated successfully',
  '选择人员': 'Select Personnel',
  '请选择人员': 'Please select personnel',
  '选择指派人员': 'Select Assignee',
  '选择转办人员': 'Select Transfer Personnel',
  '存在必填内容未填！': 'Required fields are missing!',
  '收起': 'Collapse',
  '展开': 'Expand',
  '新建工单': 'New Work Order',
  '现场勘察': 'On-site Survey',
  '设计方案': 'Design Proposal',
  '设计方案与预算': 'Design Proposal & Budget',
  '预算': 'Budget',
  '领导审批': 'Leader Approval',
  '财务缴费': 'Financial Payment',
  '现场施工': 'On-site Construction',
  '大厅复核': 'Hall Review',
  '归档': 'Archive',
  '确定归档吗?': 'Are you sure to archive?',
  '确定关闭吗?': 'Are you sure to close?',
  '驳回': 'Reject',
  '撤回': 'Withdraw',
  '确定撤回吗?': 'Are you sure to withdraw?',
  '审批': 'Approval',
  '审批派单': 'Approval Dispatch',
  '审核': 'Review',
  '财务确认': 'Financial Confirmation',
  '财务确认详情': 'Financial Confirmation Details',
  '工程验收': 'Project Acceptance',
  '录入合同': 'Enter Contract',
  '录入工程图纸和工程预算': 'Enter Drawings & Budget',
  '录入施工文件': 'Enter Construction Documents',
  '处理成功': 'Processed Successfully',
  '操作成功': 'Operation successful',
  '操作失败': 'Operation failed',
  '新增成功': 'Added successfully',
  '编辑成功': 'Updated successfully',
  'construction_detail管理页面': 'Construction Detail Management Page',
  '无图片': 'No Image',
  '无文件': 'No File',
  // 施工公司（constructionCompany）
  '公司名称': 'Company Name',
  '请输入公司名称': 'Please enter company name',
  '施工公司名称': 'Construction Company Name',
  '请输入施工公司名称': 'Please enter construction company name',
  '施工申请': 'Construction Application',
  // 报装申请表单（apply/ConstructionDetailForm）
  '安装信息': 'Installation Info',
  '区域信息': 'Area Info',
  '请选择区域': 'Please select area',
  '请选择区域信息': 'Please select area info',
  '请输入区域名称': 'Please enter area name',
  '请先选择有效区域': 'Please select a valid area first',
  '用水地址': 'Water Use Address',
  '请输入用水地址': 'Please enter water use address',
  '申请原因': 'Application Reason',
  '申请用水原因及要求': 'Water Application Reason & Requirements',
  '请输入': 'Please enter',
  '产权人信息': 'Property Owner Info',
  '产权人姓名': 'Property Owner Name',
  '请输入用户名称': 'Please enter customer name',
  '产权人身份证号': 'Property Owner ID Number',
  '身份证号': 'ID Number',
  '身份证号码': 'ID Number',
  '请输入身份证号': 'Please enter ID number',
  '请输入身份证号码': 'Please enter ID number',
  '请输入正确的身份证号': 'Please enter a valid ID number',
  '用户类别': 'Customer Category',
  '请选择用户类别': 'Please select customer category',
  '产权人身份证正反面': 'Property Owner ID Card (Front & Back)',
  '用户身份证正反面': 'Customer ID Card (Front & Back)',
  '请上传身份证正反面': 'Please upload ID card (front & back)',
  '请上传清晰的产权人身份证正反面': 'Please upload a clear property owner ID card (front & back)',
  '房产证': 'Property Certificate',
  '请上传房产证': 'Please upload property certificate',
  '请上传清晰的房产证': 'Please upload a clear property certificate',
  '是否委托': 'Entrusted or Not',
  '联系人信息': 'Contact Info',
  '联系人姓名': 'Contact Name',
  '请输入联系人姓名': 'Please enter contact name',
  '联系人电话': 'Contact Phone',
  '请输入联系电话': 'Please enter contact phone',
  '请输入正确的手机号码': 'Please enter a valid mobile phone number',
  '用户联系电话': 'Customer Contact Phone',

  '委托人姓名': 'Entrusting Party Name',
  '委托书模版': 'Letter of Authorization Template',
  '委托书模版.pdf': 'Letter of Authorization Template.pdf',
  '委托书': 'Letter of Authorization',
  '请上传委托书': 'Please upload letter of authorization',
  '被委托人身份证正反': 'Entrusted Person ID Card (Front & Back)',
  '被委托人身份证正反面': 'Entrusted Person ID Card (Front & Back)',
  '请上传被委托人身份证正反面': 'Please upload entrusted person ID card (front & back)',
  '营业执照': 'Business License',
  '请上传营业执照': 'Please upload business license',
  '请上传清晰的营业执照': 'Please upload a clear business license',
  '申请主体单位信息': 'Applicant Organization Info',
  '单位名称': 'Organization Name',
  '请输入单位名称': 'Please enter organization name',
  '单位地址': 'Organization Address',
  '请输入单位地址': 'Please enter organization address',
  '统一社会信用代码': 'Unified Social Credit Code',
  '请输入统一社会信用代码': 'Please enter unified social credit code',
  '法人信息': 'Legal Representative Info',
  '法人姓名': 'Legal Representative Name',
  '请输入法人姓名': 'Please enter legal representative name',
  '法人身份证号码': 'Legal Representative ID Number',
  '法人身份证正反面': 'Legal Representative ID Card (Front & Back)',
  '请上传清晰的法人身份证正反面': 'Please upload a clear legal representative ID card (front & back)',
  '申请公函': 'Official Application Letter',
  '单位加盖公章申请书': 'Application with Organization Seal',
  '请上传申请书': 'Please upload application letter',
  '请上传清晰的单位加盖公章申请书': 'Please upload a clear stamped company application letter',
  // 详情（modules/detail）
  '勘察相约时间': 'Survey Appointment Time',
  '勘察实际时间': 'Actual Survey Time',
  '勘测信息': 'Survey Information',
  '安全状况': 'Safety Condition',
  '正常': 'Normal',
  '恶劣': 'Harsh',
  '极度恶劣': 'Extremely Harsh',
  '施工环境': 'Construction Environment',
  '日供水量(m³)': 'Daily Water Supply (m³)',
  '设计信息': 'Design Info',
  '是否排水': 'Drainage',
  '请选择是否排水': 'Please select whether drainage is needed',
  '报装口径': 'Installation Caliber',
  '请选择表口径': 'Please select meter caliber',
  '管线长度及规格(米)': 'Pipeline Length & Specification (m)',
  '请输入管线长度及规格': 'Please enter pipeline length and specification',
  '备注信息': 'Remarks',
  '请输入备注信息': 'Please enter remark',
  '请输入备注': 'Please enter remark',
  '工程预算(元)': 'Project Budget (CNY)',
  '请输入工程预算': 'Please enter project budget',
  '预算信息': 'Budget Info',
  '收费信息': 'Charge Info',
  '合同名称': 'Contract Name',
  '合同金额(元)': 'Contract Amount (CNY)',
  '甲方': 'Party A',
  '乙方': 'Party B',
  '备注说明': 'Remark Description',
  '费用已收取': 'Fee Collected',
  '预存金额': 'Prepaid Amount',
  '合同附件': 'Contract Attachments',
  '费用附件': 'Fee Attachments',
  '施工信息': 'Construction Info',
  '是否存在设计变更': 'Design Change or Not',
  '请选择是否存在设计变更': 'Please select whether there is a design change',
  '施工备注': 'Construction Remarks',
  '请输入施工备注': 'Please enter construction remarks',
  '施工附件': 'Construction Attachments',
  '请上传施工附件': 'Please upload construction attachments',
  '验收附件': 'Acceptance Attachments',
  '请上传验收附件': 'Please upload acceptance attachments',
  '请上传附件': 'Please upload attachments',
  // 施工申请 / 核验稽查
  '施工申请描述': 'Construction Application Description',
  '请输入施工申请描述': 'Please enter construction application description',
  '施工申请照片材料': 'Construction Application Photos',
  '施工申请模版': 'Construction Application Template',
  '施工申请模板.docx': 'Construction Application Template.docx',
  '下载模板': 'Download Template',
  '核验稽查': 'Verification & Inspection',
  '核验稽查描述': 'Verification & Inspection Description',
  '请输入核验稽查描述': 'Please enter verification & inspection description',
  '核验稽查照片': 'Verification & Inspection Photos',
  // 审核表单
  '审核意见': 'Review Opinion',
  '请选择审批意见': 'Please select approval opinion',
  '通过': 'Approve',
  '请选择下一节点操作人': 'Please select next node handler',
  // 其他
  '请输入用水类别': 'Please enter water use category',
  '请选择是否委托': 'Please select whether entrusted',
}
